import React, { useState } from "react";
import SuccessModal from "./SuccessModal";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
function CheckoutForm({
  selectedPlansAndBilling,
  onSuccess,
  setCurrentStep,
  billingCycle,
  setShowSuccessModal,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const totalAmount = Object.values(selectedPlansAndBilling).reduce(
    (acc, plan) => {
      // Ensure value exists and has a price before adding
      return acc + (plan.value?.price || 0);
    },
    0
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);
    if (!stripe || !elements) {
      setError("Stripe has not loaded yet.");
      setLoading(false);
      return;
    }
    // Confirm the payment and save the payment method
    const { error: stripeError, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });
    if (stripeError) {
      setError(stripeError.message);
      setLoading(false);
      return;
    }
    // After payment method is saved, call addBusiness
    try {
      await onSuccess(setupIntent);
      setShowSuccessModal(true);
    } catch (err) {
      setError("Failed to add business.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="custom-form">
        <PaymentElement options={{ layout: "tabs" }} />
        {error && <div className="mt-2 error-text">{error}</div>}
        <div className="mt-4 flex flex-col md:flex-row justify-between">
          <button
            className="w-full bg-gray-200 btn sm:w-auto"
            onClick={() => setCurrentStep(3)}
            type="button"
          >
            Back
          </button>
          <button type="submit" className="btn" disabled={loading}>
            {loading ? "Processing..." : `Pay $${totalAmount?.toFixed(2)}`}
          </button>
        </div>
      </form>
    </>
  );
}

const Payment = ({
  clientSecret,
  handleBusinessAdd,
  setIsModalOpen,
  setShowStripe,
  setCurrentStep,
  billingCycle,
  setShowSuccessModal,
  selectedPlansAndBilling,
}) => {
  return (
    <div className="flex flex-col p-6 mx-auto bg-white rounded-lg shadow">
      <Elements stripe={stripePromise} options={{ clientSecret }}>
        <CheckoutForm
          setCurrentStep={setCurrentStep}
          selectedPlansAndBilling={selectedPlansAndBilling}
          billingCycle={billingCycle}
          setShowSuccessModal={setShowSuccessModal}
          onSuccess={async (setupIntent) => {
            await handleBusinessAdd(setupIntent.payment_method);
            setIsModalOpen(false);
            setShowStripe(false);
            setCurrentStep(1);
          }}
        />
      </Elements>
    </div>
  );
};

export default Payment;
